<app-candidate-register-form [candidateRegisterForm]="candidateRegisterForm"
                             [termsAndConditions]="termsAndConditions"
                             [countryId]="countryId"
                             (formSubmitted)="checkIfCandidateAlreadyApplied($event)"></app-candidate-register-form>
